<template>
  <div class="dashboard__view mb-5">
    <div class="list">
      <div class="tab__content">
        <div class="tab__content__top">
          <div class="tab__content__top__left">
            {{ pageInfo.total }} Payment Links
            <div class="items-flex">
              <button class="btn woven-color pt-3 pb-4" @click="generatePaymentLink">Generate Payment link</button>
            </div>
          </div>
        </div>
        <EmptyState v-if="emptyState" type="not-found" icon="transaction" />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="loading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
              <tr>
                <th>PAYMENT LINK REFERENCE</th>
                <th>Account Details</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Date Created</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                :key="item.id"
                v-for="item in transactionList"
              >
              <td>{{ item.slug}}</td>
              <td class="account-details">
                {{ item.vnuban || "Not Available" }}
                <span>{{ findBank(item.bank_code) || "Not Available"}}</span>
              </td>
              <td>{{ item.amount ? item.amount : "Not Available" }}</td>
              <td :class="item.status === 'ACTIVE' ? 'green-status' : item.status.toLowerCase() === 'FAILED' ? 'red-status' : 'other-status' ">{{ item.status }}</td>
              <td>{{ moment(item.created_at).format("llll") }}</td>
              <td @click.prevent="downloadPaymentLink(item)" class="download-text">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"  style="height: 20px; color: red;"><path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" fill="#e00b5b"/></svg>
              </td>
              </tr>
            </tbody>
          </table>
          <div
            class="table__details"
            v-if="loading !== true && emptyState !== true"
          >
            <div class="table__details__left">
              <span class="text-muted" v-if="pageInfo.total"
                >Page {{ pageInfo.current_page }} of
                {{ pageInfo.total_pages }}</span
              >
            </div>
            <div class="table__details__right">
              <Pagination :numberOfPages="pageInfo.total_pages" />
            </div>
            <div class="table__details__right"></div>
          </div>
        </div>
      </div>
      <QRTemplate :qrPaymentDetails="qrPaymentDetails" v-if="qrPaymentDetails" :download="download" @downloadedqr="download = null"/>
    </div>

  </div>
</template>

<script>
import AccountStatement from "@/components/accountStatementModal.vue";
import { formatAmount } from "@/lib/formatAmount.js";
import QRTemplate from "@/components/qrtemplate.vue";
import Pagination from "@/components/pagination.vue";
export default {
  metaInfo: {
    title: "Merchant Details",
  },
  components: {
    AccountStatement,
    QRTemplate,
    Pagination
  },
  data() {
    return {
      merchantList: {},
      merchantBalance: 0,
      loading: false,
      qrPaymentDetails: null,
      download: null,
      pageInfo: "",
      transactionList: "",
      emptyState: false,
    };
  },

  created() {
    this.fetchMerchants();
  },

  methods: {
    formatAmount,
    moment: window.moment,
    fetchTransactions() {
      this.loading = true;
      this.$http
        .get(`api/admin/payment_links/${this.$route.params.id}`)
        .then((response) => {
          if (response.body.data.paymentLinks.length > 0) {
            this.transactionList = response.body.data.paymentLinks;
            this.pageInfo = response.body.data.page_info;
            this.emptyState = false;
            this.loading = false;
          } else {
            this.emptyState = true;
            this.loading = false;
          }
        })
        .catch((error) => {
          // LOG Error
          this.loading = false;
        });
    },
    findBank(code) {
    const bankNames =         this.$store.getters.getBankList
      if (bankNames) {
          const bank = Object.values(bankNames).find(
              (bank) => bank.code == code
          );
      return bank ? bank.name : "";
      }
  },
    getBankName(code, defaultValue = null) {
      const bank = this.$store.state.bankNames[code];
      return bank
        ? bank.name || bank.bank_short_name
        : defaultValue || "Not Available";
    },
    downloadPaymentLink(item) {
      const businessName = JSON.parse(localStorage.getItem('merchantInfo')).business_name;
      this.qrPaymentDetails = { ...this.qrPaymentDetails,
        slug: item.slug,
        qr_code: item.qr_code,
        merchant_name: businessName,
        bank: this.findBank(item.bank_code),
        vnuban: item.vnuban,
      };
      this.download = 'branded';
  },
    fetchMerchants() {
      this.$http
        .get(`admin/merchants?merchantId=${this.$route.params.id}`)
        .then((response) => {
          if (response.body.data.merchants.length > 0) {
            this.merchantList = response.body.data.merchants[0];
          }
        });
      this.$http
        .post(`dashboard/accounts/balance`, {
          merchantId: this.$route.params.id,
        })
        .then((response) => {
          this.merchantBalance = response.body.data.balance;
        });
    },
    async getAccountStatement() {
      this.$v.filterList.$touch();
      if (this.$v.filterList.$invalid) {
        return;
      }
      this.loading = true;
      await this.$store.dispatch("generateAccountStatement", {
        merchantId: this.$route.params.id,
      });
      this.loading = false;
      this.clearFilter();
    },
    async generatePaymentLink() {
      try {
        const res = await this.$http.post(`api/admin/${this.$route.params.id}/payment_link`);
        const bank = res.data.data.bank_code;
        this.qrPaymentDetails = {
          slug: res.data.data.slug,
          qr_code: res.data.data.qr_code,
          merchant_name: this.merchantList.business_name,
          bank: this.getBankName(bank),
          vnuban: res.data.data.vnuban.vnuban,
        };
        this.download = 'branded';
        this.fetchTransactions();
      } catch (error) {
        this.$notify({
          group: "notifications-default",
          type: "error text-white",
          title: error.message ? error.message : 'Error',
          text: error.message ? error.message : "An error occurred while downloading QR template",
      });
      }
    },
  },
  mounted() {
    this.fetchTransactions();
  },
};
</script>
<style>
.items-flex{
  width: fit-content !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  margin-bottom: 1rem;
}
.items-flex > button{
  height: 40px;
  color: #e00b5b !important;
  border-radius: 4px !important;
  background-color: white !important;
  border: 1px solid #e00b5b !important;
}
.dropdown-item-list{
  display: flex;
  align-items: center;
  gap: 8px;
}
.tab__content__top__left{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.green-status {
  color: #00b87c !important;
}
.red-status {
  color: #e00b5b !important;
}
.other-status{
  color: #FFBF00 !important;
}
.account-details{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}
.download-text{
  font-size: 12px;
  color: #A0A3BD;
  cursor: pointer;
}
</style>
